import { Injectable, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class ConversationsService {
  messageAdded: EventEmitter<Object> = new EventEmitter();
  messagesCleared: EventEmitter<Object> = new EventEmitter();
  conversationSet: EventEmitter<Object> = new EventEmitter();

  constructor(public http: Http) {}

  start(params = {}) {
    return this.http.get(`${API_URL}/api/v1/conversations/new`, params).map(res => {
      return res.json();
    });
  }

  create(params: Object) {
    return this.http.post(`${API_URL}/api/v1/conversations`, params).map(res => {
      return res.json();
    });
  }

  update(id: number, params = {}) {
    return this.http.patch(`${API_URL}/api/v1/conversations/${id}`, params).map(res => {
      return res.json();
    });
  }

  delete(id: number, params = {}) {
    return this.http.delete(`${API_URL}/api/v1/conversations/${id}`).map(res => {
      return res.json();
    });
  }

  addMessage(message: Object) {
    let assistantChat = this.getAssistantChat();
    let updatedChat = { ...assistantChat, messages: [...assistantChat.messages, message] };
    this.updateChat(updatedChat);
    this.messageAdded.emit(message);
  }

  clearMessages() {
    let assistantChat = this.getAssistantChat();
    let updatedChat = { ...assistantChat, messages: [] };
    this.updateChat(updatedChat);
    this.messagesCleared.emit();
  }

  setConversation(conversation: Object) {
    this.conversationSet.emit(conversation);
  }

  updateChat(updatedChat: Object) {
    window.localStorage.setItem('assistantChat', JSON.stringify(updatedChat));
  }

  getAssistantChat() {
    return JSON.parse(window.localStorage.getItem('assistantChat'));
  }
}



// WEBPACK FOOTER //
// ./src/providers/conversations.ts